import React, {useState} from "react"

import {FieldViewSize} from "../../../../../const"

export default function FieldTimeReported_InlineValueNotEmpty(props:any) {

    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) {
            setIsHovered(true)
        }
    }

    const onMouseLeave = () => {
        if (isHovered) {
            setIsHovered(false)
        }
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        props.onChange(null)
    }

    const className = Classes("ui5-field-editable", "size-"+size, props.className, {
        'is-hovered': isHovered || props.children
    })

    const valueFormatted = props.field.getDisplayValue(props.value, props?.configOptions?.showPlaceholder)

    const valueClass = Classes('txt-truncate', {
        'ui5-txt-default'               : size === FieldViewSize.DEFAULT,
        'ui5-txt-less-important-small'  : size === FieldViewSize.SMALL,
    })

    if (isHovered || props.children) {
        return (
            <>
                <div className      = {className}
                     onMouseEnter   = {onMouseEnter}
                     onMouseLeave   = {onMouseLeave}
                     onClick        = {props.onClick}
                >
                    <div className={valueClass}>{valueFormatted}</div>
                    {props.field.clearButton &&
                        <div className="buttons">
                            <div className  = "btn-reset"
                                 onClick    = {onDeleteClick}
                            />
                        </div>
                    }
                </div>
                {props.children}
            </>
        )
    }

    // not hovered
    return (
        <>
            <div className      = {Classes(className, valueClass)}
                 onMouseEnter   = {onMouseEnter}
                 onMouseLeave   = {onMouseLeave}
                 onClick        = {props.onClick}
            >
                {valueFormatted}
            </div>
            {props.children}
        </>
    )
}
